import {
  IPayloadGetLatestData,
  ILatestData,
  IGetDetailIndicatorLatestData,
} from 'src/types/latest_data';
import { createClient } from './axios_client';

const client = createClient('http://localhost:9003/api/v1');

export const latestDataApi = {
  getLatestData: (payload: IPayloadGetLatestData) => {
    return client.get<{ data: ILatestData[]; totalData: number }>('/latest_data', {
      params: payload,
    });
  },

  getIndicatorDetailInfo: ({ stationId, symbol }: { stationId: string; symbol: string }) => {
    return client.get<IGetDetailIndicatorLatestData>(`/stations/${stationId}/indicator/${symbol}`);
  },

  getStationDataLast: (stationId: string) => {
    return client.get<ILatestData>(`/latest_data/${stationId}`);
  },
};
